<template>
  <div>
    <el-transfer
      filterable
      :titles="['未选', '已选']"
      :value="packages"
      :data="data"
      @input="change($event)"
    >
    </el-transfer>
  </div>
</template>

<script>

import { fetchPackageList } from '../api/package'
export default {
  data () {
    return {
      data: [],
      packages: []
    }
  },
  created () {
    let query = {}
    const data = []
    query.limit = 1000
    query.page = 1
    fetchPackageList(query).then((res) => {
      const _res = res.data.map((item) => { item.id = parseInt(item.id); return item })
      _res.forEach((item, index) => {
        data.push({
          label: item.desc,
          key: item.id
        })
      })
      this.data = data
    })
  },
  mounted () {
    this.packages = this.value
  },
  props: ['value', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.packages = val
      this.$emit('input', val)
    }
  },
  watch: {
    value (val) {
      this.packages = val
    }
  }
}
</script>

<style>
  @media screen and (min-width: 1300px) {
    .el-transfer-panel {
      width: 35%;
    }
  }
  @media screen and (max-width: 1300px) {
    .el-transfer-panel {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/card/components/PackageTransfer.vue